
<t4-card class="card-profile card-activity" [showFooter]="inDialog === false" cardTitle="{{'ACTIVITY.LOG.CARD.TITLE' | translate}}">

  <ng-container data-body>

    @if (activities.length === 0) {
      <div>{{'ACTIVITY.LOG.NO.HISTORY' | translate}}</div>
    }

    <div class="media-list pd-t-10">
      @for (activity of activities; track activity) {
        <div class="media">
          <div class="activity-icon bg-primary">
            <i [class]="getActionIcon(activity)"></i>
          </div><!-- activity-icon -->
          <div class="media-body pt-0">
            <b>{{userName(activity)}} {{getActionDescription(activity)}}</b><br />
            <span>{{(activity.Created || null) | localDateTime | replaceOnEmpty }}</span>
          </div><!-- media-body -->
        </div>
        }<!-- media -->

      </div><!-- media-list -->

    </ng-container>
    @if (inDialog === false) {
      <ng-container data-footer-right>
        <div style="min-height: 24px;">
          <span (click)="showHistory()" class="action-text clickable" >{{'ACTIVITY.LOG.SHOW.COMPLETE.HISTORY' | translate}}</span>
        </div>
      </ng-container>
    }

  </t4-card>
